import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StyledRange, StyledInputBlock, StyledLabel, StyledInput, StyledButton } from './Styled';
import { setSuperTrackEndTime, setSuperTrackStartTime } from '@/store/supertrackSlice';

export const VideoRangeInput = () => {
  const dispatch = useDispatch();
  const { superTrackStartTime, superTrackEndTime, superTrackGlobalVideoDuration } = useSelector(({ superTracks }) => superTracks);
  const [start, setStart] = useState(superTrackStartTime);
  const [end, setEnd] = useState(superTrackEndTime);

  const handleStartChange = (event) => {
    const newValue = event.target.value;
    setStart(newValue);
    localStorage.setItem('start', newValue);
  };

  const handleEndChange = (event) => {
    const newValue = event.target.value;
    setEnd(newValue);
    localStorage.setItem('end', newValue); 
  };

  const handleSubmit = () => {
    dispatch(setSuperTrackStartTime(start));
    dispatch(setSuperTrackEndTime(end));
  };

  useEffect(() => {
    if (end > superTrackGlobalVideoDuration && superTrackGlobalVideoDuration !== 0) {
      setEnd(superTrackGlobalVideoDuration);
      dispatch(setSuperTrackEndTime(superTrackGlobalVideoDuration));
      localStorage.setItem('end', superTrackGlobalVideoDuration);
    }
  }, [end, superTrackGlobalVideoDuration]);

  return (
    <StyledRange>
      <StyledInputBlock>
        <StyledLabel>Start of video</StyledLabel>
        <StyledInput
          type="number"
          placeholder="start"
          value={start}
          onChange={handleStartChange}
        />
      </StyledInputBlock>
      <StyledInputBlock>
        <StyledLabel>End of video</StyledLabel>
        <StyledInput
          type="number"
          placeholder="end"
          value={end}
          onChange={handleEndChange}
        />
      </StyledInputBlock>
      <StyledInputBlock>
        <StyledButton onClick={handleSubmit}>Submit</StyledButton>
      </StyledInputBlock>
    </StyledRange>
  );
}
